import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

export default class SignUp extends Component {
  constructor(props){
    super(props)
    this.state = {
      email: '',
      password: '',
      user: null,
      disabled: true,

    }
  }

   handleSignIn = (email, password) => {
    //console.log('signing in...')
    firebase.auth().signInWithEmailAndPassword(email, password)
    .then((signInObj) => {
        if (signInObj) {
          let user = signInObj.user;
          let name = user.displayName;
          this.setState({user: user, name: name, signedIn: true})
          this.props.signInCallback(true, user);
          this.props.history.push("/home");
        } 
    })
      .catch((err) => {
        console.log(err.message)
        let error = <p className="alert alert-danger mt-2"><strong>{err.message}</strong></p>;
        this.setState({errorMessage: error});
      })

    }

  handleChange = (event) => {
        let field = event.target.name; //which input
        let value = event.target.value; //what value
        let missing = this.getMissingField()
        if (missing.length > 0){
          this.setState( {[field]: value, disabled: true})
        } else {
          this.setState( {[field]: value, disabled: false})
        }
  }

  getMissingField = () => {
    let allFields = {
      email: this.state.email, 
      password: this.state.password, 
    };

    let missing = [];
    Object.keys(allFields).map( (key) => {
      if (allFields[key] === ""){
        missing.push(key);
      }
      return key;
    });
    return missing;
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let missingField = this.getMissingField();
    let error = '';

    let fieldStr = 'feild';
    if(missingField.length > 1){
      fieldStr = 'feilds';
    }

    if (missingField.length > 0){
      let missingStr = missingField.toString().replace(/,/g, ', ').replace(/,([^,]*)$/,', and$1');
      error = <p className="alert alert-danger mt-2"><strong>Please fill in the {missingStr} {fieldStr}.</strong></p>;
      this.setState( {fillInError: error, disabled: true} );
    } else {
      this.handleSignIn(this.state.email, this.state.password);
      this.setState( {disabled: false, errorMessage: '', fillInError: ''} );
    }

    
  }
  

  render() {
    return (
      <div>
        {this.state.fillInError}
        {this.state.errorMessage}
        <form>
          <label>Email</label>
          <br></br>
          <input onChange={this.handleChange}
          type="email"
          name="email"
          id="email"
          placeholder="email..."
          value={this.state.email}></input>
          <br></br>
          <label>Password</label>
          <br></br>
          <input onChange={this.handleChange}
          type="password"
          name="password"
          id="password"
          placeholder="password..."
          value={this.state.password}></input>
          <br></br>
          <button onClick={this.handleSubmit} className="green-button signin-button" aria-label="button" disabled={this.state.disabled} href="/home">Sign In</button>
          <br></br>
        </form>
        <p className="or"><span>or</span></p>
          <StyledFirebaseAuth uiConfig={this.props.uiConfig} firebaseAuth={firebase.auth()}/>
      </div>
    )
  }
}